import { injectBetData } from "../lib/provideInjectors";
import { computed } from "vue";
import { addLinksClickUrl } from "../lib/addClickUrl";

export function useBetData() {
  const betData = injectBetData();
  const markets = computed(() => betData.value?.markets);
  const marketNames = computed(
    () =>
      (markets.value &&
        Object.values(markets.value).map(market => market.marketType)) ||
      []
  );
  const events = computed(() => betData?.value?.events);
  const options = computed(() => betData?.value?.options);

  const clickUrl = computed(() => betData.value?.clickUrl);

  const links = computed(() => {
    const links = betData.value?.links;
    return links && addLinksClickUrl(links, clickUrl.value);
  });

  const catalogId = computed(() => {
    return betData.value.analytics.catalogueId;
  });

  const viewId = computed(() => {
    return betData.value.analytics.viewId;
  });

  const campaignId = computed(() => {
    return betData.value.analytics.campaignId || "";
  });

  return {
    events,
    eventIds: computed(() => (events.value && Object.keys(events.value)) || []),
    markets,
    options,
    marketNames,
    links,
    catalogId,
    viewId,
    campaignId
  };
}
